import React, { useState, useEffect } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Table,
  Modal,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import ReactPaginate from "react-paginate"
import axios from "axios"
import { URLS } from "../../Url"
import { saveAs } from "file-saver"
import { CSVLink } from "react-csv"

const Banner = () => {
  const [modal_small, setmodal_small] = useState(false)
  const [banner, setbanner] = useState([])
  const [form, setform] = useState([])
  const [form1, setform1] = useState([])
  console.log(form1)
  const [form12, setform12] = useState(false)

  const [filter, setFilter] = useState(false)
  const [filters, setFilters] = useState({ fromDate: "", toDate: "" })
  const handleChangeflt = e => {
    let myUser = { ...filters }
    myUser[e.target.name] = e.target.value
    setFilters(myUser)
  }
  const handleReset = () => {
    setFilters({ fromDate: "", toDate: "" })
    setPageNumber(0)
    GetAllProductcat()
  }
  const hidefilter = () => setFilter(false)

  function tog_small() {
    setmodal_small(!modal_small)
  }

  const handleChange = e => {
    let myUser = { ...form12 }
    myUser[e.target.name] = e.target.value
    setform12(myUser)
  }
  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  useEffect(() => {
    GetAllProductcat()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const [listPerPage] = useState(10)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = banner.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(banner.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const EditProductcat = () => {
    var token = datas
    var formid = form1._id
    const dataArray = new FormData()
    dataArray.append("priority", form1.priority)
    dataArray.append("priorityName", form1.priorityName)
    axios
      .post(URLS.EditPriorityStatus + formid, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetAllProductcat()
            setmodal_small(false)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const csvReport = {
    filename: "Products Report",
    data: form,
  }

  const handleSubmit1 = e => {
    e.preventDefault()
    EditProductcat()
  }

  const GetAllProductcat = () => {
    var token = datas
    axios
      .post(
        URLS.GetProduct,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setbanner(res.data.products)
        setform(
          res.data.products.map(data => ({
            Date: data.logCreatedDate.slice(0, 10),
            "Product Name": data.productName,
            Brand: data.brand,
            "Category Name": data.enterCategory,
            Photos: URLS.Base + data.photos,
            Video: URLS.Base + data.video,
            Price: data.price,
            Priority: data.priority,
            IsPlatinum: data.priorityName,
            "User Name": data.userName,
            Phone: data.whatsAppNo,
            Address: data.address,
          }))
        )
      })
  }

  const GetAllProductfilter = e => {
    e.preventDefault()
    var token = datas
    const bodydata = {
      fromDate: filters.fromDate,
      toDate: filters.toDate,
    }

    axios
      .post(URLS.GetProduct, bodydata, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setbanner(res.data.products)
        hidefilter()
        setFilters({ fromDate: "", toDate: "" })
        setform(
          res.data.products.map(data => ({
            Date: data.logCreatedDate.slice(0, 10),
            "Product Name": data.productName,
            Brand: data.brand,
            "Category Name": data.enterCategory,
            Photos: URLS.Base + data.photos,
            Video: URLS.Base + data.video,
            Price: data.price,
            Priority: data.priority,
            IsPlatinum: data.priorityName,
            "User Name": data.userName,
            Phone: data.whatsAppNo,
            Address: data.address,
          }))
        )
      })
  }

  const DeleteProducutcat = data => {
    var token = datas
    var remid = data._id
    axios
      .post(
        URLS.DeleteProduct + remid,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetAllProductcat()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      DeleteProducutcat(data)
    }
  }

  const getpopup = data => {
    setform1(data)
    tog_small()
  }

  const [search, setsearch] = useState([])

  const searchAll = e => {
    let myUser = { ...search }
    myUser[e.target.name] = e.target.value
    setsearch(myUser)

    var token = datas
    axios
      .post(
        URLS.GetProductSearch + `${e.target.value}`,
        {},

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setbanner(res.data.products)
      })
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  const downloadImage = url => {
    saveAs(url, url.split("/").pop())
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home " breadcrumbItem="Product" />
          {filter && (
            <Card>
              <CardBody>
                <Form
                  onSubmit={e => {
                    GetAllProductfilter(e)
                  }}
                >
                  <Row>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="community-filter">
                          From Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="community-filter"
                          className="form-controle"
                          required
                          type="date"
                          value={filters.fromDate}
                          name="fromDate"
                          onChange={handleChangeflt}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="community-filter">
                          To Date <span className="text-danger">*</span>
                        </Label>
                        <Input
                          id="community-filter"
                          className="form-controle"
                          type="date"
                          required
                          value={filters.toDate}
                          name="toDate"
                          onChange={handleChangeflt}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mt-4">
                        <Button type="submit" className="m-1" color="info">
                          <i className="fas fa-check-circle"></i> Search
                        </Button>
                        <Button
                          onClick={hidefilter}
                          className="m-1"
                          color="danger"
                        >
                          <i className="fas fa-times-circle"></i> Cancel
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          )}

          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <div>
                    <Row>
                      <Col>
                        <Button
                          className="m-1"
                          onClick={() => setFilter(!filter)}
                          color="info"
                        >
                          <i className="fas fa-filter"></i> Filter
                        </Button>
                        <Button
                          className="m-1"
                          onClick={handleReset}
                          color="info"
                        >
                          <i className="fas fa-sync-alt"></i> Reset
                        </Button>
                        <CSVLink {...csvReport}>
                          <button
                            className="btn btn-success me-2"
                            type="submit"
                          >
                            <i className="fas fa-file-excel"></i> Excel
                          </button>
                        </CSVLink>
                      </Col>
                      <Col>
                        <div style={{ float: "right" }}>
                          <Input
                            type="search"
                            className="form-control"
                            placeholder="Search.."
                            value={search.search}
                            onChange={searchAll}
                            name="search"
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="table-responsive">
                      <Table className="table table-bordered mb-4 mt-5">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th> Date</th>
                            <th> Product Name</th>
                            <th> Brand</th>
                            <th> Category</th>
                            <th> Price</th>
                            <th> Priority</th>
                            <th>Platinum</th>
                            <th>Paid Amount</th>
                            <th>Status</th>
                            <th> User Name</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((data, key) => (
                            <tr key={key}>
                              <th>{(pageNumber - 1) * 10 + key + 11}</th>
                              <td>{data.logCreatedDate.slice(0, 10)}</td>
                              <td>{data.productName}</td>
                              <td>{data.brand}</td>
                              <td>{data.enterCategory}</td>
                              <td>₹ {data.price}</td>
                              <td> {data.priority}</td>
                              <td> {data.priorityName == "" ? "No" : "Yes"}</td>
                              <td>₹ {data.paid}</td>
                              <td className="text-success"> Paid</td>
                              <td> {data.userName}</td>
                              <td>
                                <Button
                                  onClick={() => {
                                    getpopup(data)
                                  }}
                                  className="m-1 btn-sm"
                                  color="success"
                                >
                                  <div className="d-flex">
                                    <small>
                                      <i className="bx bx-edit m-1"></i>
                                      Update
                                    </small>
                                  </div>
                                </Button>

                                <Button
                                  onClick={() => {
                                    manageDelete(data)
                                  }}
                                  className="m-1 btn-sm"
                                  color="danger"
                                >
                                  <div className="d-flex">
                                    <small>
                                      <i className="bx bx-trash m-1"></i>
                                      Delete
                                    </small>
                                  </div>
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Modal
            size="md"
            isOpen={modal_small}
            toggle={() => {
              tog_small()
            }}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="mySmallModalLabel">
                Edit Product Category
              </h5>
              <button
                onClick={() => {
                  setmodal_small(false)
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form
                onSubmit={e => {
                  handleSubmit1(e)
                }}
              >
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Platinum <span className="text-danger">*</span>
                  </Label>
                  <select
                    type="text"
                    className="form-select"
                    id="basicpill-firstname-input1"
                    required
                    name="priorityName"
                    value={form1.priorityName}
                    onChange={e => {
                      handleChange1(e)
                    }}
                  >
                    <option value="">Select</option>
                    <option value="Platinum">Yes</option>
                    <option value="">No</option>
                  </select>
                </div>
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Priority <span className="text-danger">*</span>
                  </Label>
                  <select
                    type="text"
                    className="form-select"
                    id="basicpill-firstname-input1"
                    required
                    name="priority"
                    value={form1.priority}
                    onChange={e => {
                      handleChange1(e)
                    }}
                  >
                    <option value="">Select</option>
                    {[...Array(100)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                </div>

                <div style={{ float: "right" }}>
                  <Button
                    onClick={() => {
                      setmodal_small(false)
                    }}
                    color="danger"
                    type="button"
                  >
                    Cancel <i className="fas fa-times-circle"></i>
                  </Button>
                  <Button className="m-1" color="primary" type="submit">
                    Submit <i className="fas fa-check-circle"></i>
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>
        </Container>

        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default Banner
